<template>
  <typeahead
    :items="groups"
    :class="{ transparentField: disabled }"
    class="group-typeahead"
    :current-items="current"
    :label-text="$tc('GROUP', multiple ? 2 : 1) | capitalize"
    :placeholder-text="$tc('GROUP', multiple ? 2 : 1) | capitalize"
    :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('GROUP', 2) })"
    :select-handler="groupSelected"
    :remove-handler="groupRemoved"
    :create-handler="groupCreated"
    :match-extractor="matchExtractor"
    :label-style="colorLabelStyle"
    :disabled="disabled"
    :multiple="multiple"
    :description="description"
  >
    <template slot="selected" slot-scope="props">
      <span :title="props.item.description">
        <span class="selected detail" v-if="props.item.detail">
          {{ props.item.detail }}
        </span>
        {{ props.item.name }}
      </span>
    </template>
    <template slot="dropdown" slot-scope="props">
      <div class="dropdown-item">
        <div class="group-color">
          <color-label :color="props.item.color" size="tiny" />
        </div>
        <div
          class="name"
          :title="(props.item.detail ? props.item.detail + ' ' : '') + props.item.name"
        >
          <span class="detail" v-if="props.item.detail">{{ props.item.detail }}</span>
          {{ props.item.name }}
        </div>
        <div class="description" v-if="props.item.description" :title="props.item.description">
          {{ props.item.description }}
        </div>
      </div>
    </template>
  </typeahead>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../scss/variables';
.group-typeahead {
  .description,
  .detail {
    opacity: 0.4;
  }
}

.selected.detail {
  font-size: 0.8em;
  padding-right: 5px;
}

.dropdown-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  .detail {
    font-size: 0.8em;
    padding-right: 5px;
  }

  div {
    padding: 5px;
  }

  .description {
    margin-left: auto;
    order: 2;
  }
}
</style>

<script>
// @flow
import { Typeahead } from 'ui'
import ColorLabel from '../ColorLabel/ColorLabel'
import { Color } from 'services'

export default {
  name: 'grouptypeahead',
  components: { Typeahead, ColorLabel },
  props: {
    multiple: {
      type: Boolean,
      default: () => true
    },
    allGroups: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    currentGroups: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    groups() {
      return _.sortBy(_.map(this.allGroups, this.formatGroup), 'name')
    },
    current() {
      return _.sortBy(_.map(this.currentGroups, this.formatGroup), 'name')
    }
  },

  methods: {
    groupSelected(g) {
      this.$emit('selected', g)
    },
    groupCreated(g) {
      this.$emit('created', g)
    },
    groupRemoved(g) {
      this.$emit('removed', g)
    },
    getName(name) {
      const indexOfDomainSeparator = name.indexOf('\\')
      if (indexOfDomainSeparator !== -1) {
        return name.substr(indexOfDomainSeparator + 1)
      }
      return name
    },
    getDomain(name) {
      const indexOfDomainSeparator = name.indexOf('\\')
      if (indexOfDomainSeparator !== -1) {
        return name.substr(0, indexOfDomainSeparator)
      }
      return ''
    },
    formatGroup(g) {
      return {
        ...g,
        name: this.getName(g.name),
        // detail is reserved for the number of subgroups or the domain name
        detail: !_.isEmpty(g.group) ? g.group.length : this.getDomain(g.name),
        description: g.name + (g.description ? ' — ' + g.description : '')
      }
    },
    matchExtractor(g) {
      return `${g.detail} ${g.name} ${g.description}`
    },
    colorLabelStyle(c: any) {
      // If the group contains other groups we will outline it
      return Color.colorLabelStyle(c, !_.isEmpty(c.group))
    }
  }
}
</script>
